import { useQuery } from '@tanstack/react-query';
import { getEmailSenders } from '../../services/marketing';
import useGetMarketingData from './useGetMarketingData';

function useGetEmailSenders({ enabled = true }: { enabled?: boolean } = {}) {
  const { data: marketingData } = useGetMarketingData();

  const { data, isLoading, isFetching, isError, refetch } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['emailSenders', marketingData?.id],
    queryFn: async () => (await getEmailSenders(marketingData?.id!)) ?? null,
    enabled:
      enabled && !!marketingData?.id && !!marketingData?.sourceBusinessId,
    staleTime: 0,
  });

  return { emailAddresses: data, isLoading, isFetching, isError, refetch };
}

export default useGetEmailSenders;
